<template>
    <div 
        class="md info-borad"
        :class="[hover? 'is-hover': '', active? 'is-active': '']"
        @click.prevent="click"
    >
        <div
            v-if="caption !== undefined"
            class="caption"
        >{{ caption }}</div>
        <div class="div">
            <div class="essay"
                v-if="text !== undefined"
                v-html="text"
            ></div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import cpLink from '@/components/cpLink'

    export default {
        components: {
            cpLink,
        },
        props: {
            caption: {
                type: String,
                require: false,
            },
            text: {
                require: false,
            },
            hover: {
                type: Boolean,
                require: false,
                default: true
            },
            active: {
                type: Boolean,
                require: false,
                default: false
            }
        },
        methods: {
            click: function(){
                this.$emit('click');
            },
        },
    }
</script>

<style scoped lang="scss">

    .md.info-borad {
        border-radius: $border-radius;
        background-color: $minor-color;

        &.is-active {
            background-color: $major-color;
            color: $white;
        }

        &.is-hover {
            cursor: pointer;
            transition: $transition;

            &:hover {
                opacity: $opacity-m;
            }
        }

        .caption {
            padding: $interval-m $interval-l;
            font-weight: bold;

            @include media('phone') {
                padding: $interval-s;
                text-align: center;
            }

            + .div {
                padding: 0 $interval-l $interval-m;

                @include media('phone') {
                    padding: 0 $interval-s $interval-m;
                }
            }
        }

        .div {
            padding: $interval-l;
            font-size: $font-size-xxxxl;
            text-align: center;

            @include media('phone') {
                font-size: $font-size-xxl;
            }

            .essay {

            }
        }
    }
</style>
